import { useState } from "react";
import submit from "submit-form";
import ConfirmationModal from "../../../../parts/modals/ConfirmationModal";
import { WORKFLOW_NAME_MAP } from "../data/customWorkflowsList";
import SvgIcon from "../../../../parts/SvgIcon";
import { OPTION_NAME_MAP } from "../data/getting-started";
import ToolTip from "../../../../parts/tooltip";

const publishWorkflow = (id, options) => {
  const publishedOption = Object.keys(options).some((key) => {
    return options[key].status === "published";
  });
  if (!publishedOption) {
    return alert("Publish at least one option before publishing the workflow");
  }
  submit(`/actions/custom-workflows/publish/${id}`, {
    method: "GET",
  });
};

const unpublishWorkflow = (id) => {
  submit(`/actions/custom-workflows/unpublish/${id}`, {
    method: "GET",
  });
};

const WorkflowToggle = ({ status, id, options }) => {
  const published = status === "published";
  const [openedConfirmationModal, setOpenedConfirmationModal] = useState(false);

  const handleChange = () => {
    published ? unpublishWorkflow(id) : publishWorkflow(id, options);
    setTimeout(() => {
      setOpenedConfirmationModal(false);
    }, 250);
  };
  return (
    <>
      <input
        type="checkbox"
        id={`switch-${id}`}
        name={`switch-${id}`}
        role="switch"
        onChange={() => {
          setOpenedConfirmationModal((prev) => !prev);
        }}
        checked={published}
      />
      <ConfirmationModal
        title={published ? "Unpublish" : "Publish"}
        contentText={`Are you sure you want to ${
          published ? "unpublish" : "publish"
        } this workflow?`}
        cancelButtonText="Cancel"
        cancelButtonAction={() => {
          setOpenedConfirmationModal((prev) => !prev);
        }}
        confirmButtonText={published ? "Unpublish" : "Publish"}
        confirmButtonAction={() => handleChange()}
        isOpen={openedConfirmationModal}
        confirmSuccess={!published}
      />
    </>
  );
};

export const CustomWorkflowsList = ({ workflows }) => {
  return (
    <section>
      {workflows &&
        workflows.map(({ _id, status, type, options, access }) => {
          // This is just to show the option on the Getting Started card, doesn't affect anything else
          // If you use the options directly it will affect the workflow
          // We don't want meme ids on the actual db
          const modifiedOptions = { ...options };
          if (
            access === "pull" &&
            type === "getting-started" &&
            !modifiedOptions.questionnaire
          ) {
            modifiedOptions.questionnaire = {
              _id: "just-click-edit-workflow-bro",
              status: "draft",
            };
          }

          return (
            <article key={_id} id={_id} className="workflow-card">
              <div className="body">
                <p className="s2">{WORKFLOW_NAME_MAP[type] || ""}</p>
                <p className="p5 mt-1 mb-4">
                  {Object.keys(modifiedOptions).length} Options
                </p>
                <div className={`status-chip ${status}`}>
                  <span className="capitalize">{status}</span>
                  <ToolTip
                    id="status-tooltip"
                    body={
                      status === "published"
                        ? "Your users will see this workflow in the app"
                        : "Your users won't see this workflow in the app, you can fill out the options you want and then publish it"
                    }
                  >
                    <span className="status-chip-icon">?</span>
                  </ToolTip>
                </div>
                {Object.keys(modifiedOptions).map((key) => (
                  <div className="option" key={modifiedOptions[key]._id ?? key}>
                    <SvgIcon
                      src={
                        modifiedOptions[key].status === "published"
                          ? "/img/new-icons/tick-square.svg"
                          : "/img/new-icons/info-circle.svg"
                      }
                      noFilterOnLight
                    />
                    <p className="p5">{OPTION_NAME_MAP[key]}</p>
                  </div>
                ))}
              </div>
              <footer>
                <button
                  data-button-type="text"
                  className="s2 clipped"
                  onClick={() => {
                    submit(`/actions/refresh/?`, {
                      method: "GET",
                      body: {
                        workflow: _id,
                        type,
                      },
                    });
                  }}
                >
                  <span>Edit Workflow</span>
                </button>
                <WorkflowToggle status={status} id={_id} options={options} />
              </footer>
            </article>
          );
        })}
    </section>
  );
};
